module.exports = __webpack_public_path__ + "img/logo-company.481b7a1e.png";